<div class="mb-4 rounded-2xl p-4">
  <app-partially-delivered-reasons-create-component></app-partially-delivered-reasons-create-component>
</div>